import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import KeyboardDoubleArrowRightOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setIsMenuExpanded } from "../../app/slices/GlobalSlice";
import PiUserButton from "./PiAccountButton";
import PiIconButton from "./PiIconButton";
import "./PiMenu.css";
import classNames from "classnames";
import PiTag from "../../components/PiTag";

const playItCreatorLogo = require("../../assets/PlayItCreator.png");
const playItLogoCompact = require("../../assets/PlayItLogo_Compact.png");

interface PiMenuProps {
  children?: React.ReactNode;
}

export default function PiMenu(props: PiMenuProps) {
  const [isMenuExpanded, setMenuExpandend] = useState(true);
  const dispatch = useDispatch();
  const version = process.env.REACT_APP_PLAYIT_APP_VERSION ?? "not-set";

  const toggleMenuExpanded = () => {
    const newState = !isMenuExpanded;
    setMenuExpandend(newState);
    dispatch(setIsMenuExpanded(newState));
  };

  const rootClassnames = isMenuExpanded
    ? "pimenu-root expanded"
    : "pimenu-root collapsed";
  const collapseButtonClassnames = isMenuExpanded
    ? "pimenu-bottom-collapse-button pimenu-bottom-collapse-button-expanded"
    : "pimenu-bottom-collapse-button";
  const bottomContentClassnames = isMenuExpanded
    ? "pimenu-bottom-content pimenu-bottom-content-expanded"
    : "pimenu-bottom-content";
  const menuLogo = isMenuExpanded ? playItCreatorLogo : playItLogoCompact;
  const collapseIcon = isMenuExpanded ? (
    <KeyboardDoubleArrowLeftOutlinedIcon />
  ) : (
    <KeyboardDoubleArrowRightOutlinedIcon />
  );

  return (
    <div className={rootClassnames} data-testid="pimenu-root">
      <div className="pimenu-logo" data-testid="pimenu-logo">
        <img src={menuLogo} alt="Play It Creator Logo" />
      </div>
      <div className="pimenu-logo-small" data-testid="pimenu-logo-small">
        <img src={playItLogoCompact} alt="Play It Creator Logo" />
      </div>
      <div className="pimenu-button-container" data-testid="pimenu-button-container">{props.children}</div>
      <div className="h-[160px] min-h-[160px] border-t-[2px] border-t-solid border-t-creator-border flex flex-col justify-center">
        <div
          className={classNames(
            "flex flex-1 justify-center items-center px-[12px]",
            {
              "flex-col w-[64px]": !isMenuExpanded,
            }
          )}
        >
          <PiUserButton isMenuExpanded={isMenuExpanded} />
          <div
            className={classNames("pimenu-bottom-collapse-button", {
              "pimenu-bottom-collapse-button-expanded": isMenuExpanded,
            })}
          >
            <PiIconButton icon={collapseIcon} onClick={toggleMenuExpanded} />
          </div>
        </div>
        <div className="w-full h-[42px] flex justify-center items-center px-[8px]">
          <PiTag variant="blue" text={"v" + version} />
        </div>
      </div>
    </div>
  );
}
